/* eslint-disable react/display-name */
import { Avatar, Badge, Button, Space, TableColumnType, Tooltip } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { BillingCategoryName } from '../../../models/billingCategory'
import { DateTimeFormat, DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'
import { decrypt } from '../../../models/m'
import { getTransactionQueryName } from '../../../models/TransactionQuery'
import { ToothComponents } from '../../treatment/editor/modals/toothComponents'
import { useSelector } from 'react-redux'
import { selectEdition } from '../../../app/applicationSlice'
import { ColDef } from 'ag-grid-community'
import { getChrgitmLvName } from '../../../models/commodity'
import { getMaskPhone } from '../../../models/phone'

export const Columns = (startIndex?: any): TableColumnType<any>[] => {
  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      ellipsis: true,
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '结算编号',
      key: 'paymentId',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, r) => (r?.paymentId ? r?.paymentId : '-'),
    },
    {
      title: '门诊号',
      key: 'outpatientNo',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => (r?.outpatientNo ? r?.outpatientNo : '-'),
    },
    {
      title: '患者姓名',
      key: 'patientName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, r) => (r?.patientName ? r?.patientName : '-'),
    },
    {
      title: '病历号',
      key: 'patientId',
      align: 'center',
      width: '8em',
      ellipsis: true,
      dataIndex: 'patientId',
      render: (_, r) => (r?.patientId > -1 ? r?.patientId : '-'),
    },
    {
      title: '身份证号',
      key: 'idCardNumber',
      align: 'center',
      width: '14em',
      dataIndex: 'idCardNumber',
      render: (_, r) => (r?.idCardNumber ? r?.idCardNumber : '-'),
    },
    {
      title: '手机号',
      key: 'patientPhone',
      align: 'center',
      width: '10em',
      ellipsis: true,
      dataIndex: 'patientPhone',
      render: (_, r) => {
        return r?.patientPhone ? decrypt(r?.patientPhone) : '-'
      },
    },
    {
      title: '诊断疾病',
      key: 'disease',
      align: 'center',
      width: '10em',
      ellipsis: true,
      dataIndex: 'disease',
      render: (_, r) => {
        return r?.disease ? r?.disease : '-'
      },
    },
    {
      title: '接诊医生',
      key: 'treatmentDoctorName',
      align: 'center',
      width: Dimen.Doctor,
      ellipsis: true,
      render: (_, r) => (r?.treatmentDoctorName ? r?.treatmentDoctorName : '-'),
    },
    {
      title: '收费时间',
      key: 'chargeOrRefundTime',
      align: 'center',
      width: '12em',
      ellipsis: true,
      render: (_, r) => {
        return r?.chargeOrRefundTime
          ? moment(r?.chargeOrRefundTime)?.format(DateTimeFormat)
          : '-'
      },
    },
    {
      title: '结算险种',
      dataIndex: 'insuranceCode',
      width: '8em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.insuranceCode === 'ZIFEI' || !r?.insuranceCode
          ? '自费'
          : '智慧医保'
      },
    },
    {
      title: '人员险种',
      dataIndex: 'xianzhonglx',
      width: '8em',
      ellipsis: true,
      align: 'center',
      render: (_, r) => {
        return r?.xianzhonglx == 310 ? '职工'
          : r?.xianzhonglx == 390 ? '居民'
            : r?.xianzhonglx == 340 ? '离休'
              : '-'
      },
    },
    {
      title: '开票项目',
      width: '8em',
      align: 'center',
      ellipsis: true,
      dataIndex: 'billingCategory',
      render: (_, t) => {
        return BillingCategoryName(t?.billingCategory)
      },
    },
    {
      title: '项目名称',
      key: 'drugName',
      width: '14rem',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.drugName ? r?.drugName : '-'
      },
    },
    {
      title: '牙位',
      key: 'toothStruct',
      width: '14rem',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: 8
          }}>
            <ToothComponents data={r.toothStruct} isEdit={false} />
          </div>
        )
      },
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return (
          <div
            style={{
              color: r?.state == 5 ? 'red' : '',
            }}
          >
            {Number(r?.retailPrice) > -1 ? r?.retailPrice.toFixed(2) : '-'}
          </div>
        )
      }
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return (
          <div
            style={{
              color: r?.state == 5 ? 'red' : '',
            }}
          >
            {Number(r?.drugCount) > -1 ? r?.drugCount : '-'}
          </div>
        )
      }
    },
    {
      title: '金额',
      dataIndex: 'drugAmount',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {

        return (
          <div
            style={{
              color: r?.state == 5 ? 'red' : '',
            }}
          >
            {Number(r?.drugAmount) > -1 ? r?.drugAmount.toFixed(2) : '-'}
          </div>
        )

      },
    },
    {
      title: '支付方式',
      align: 'center',
      key: 'payMethodName',
      width: Dimen.Time,
      ellipsis: true,
      render: (_, t) => {
        return t?.payMethodName ? t?.payMethodName : '-'
      }
    },
    {
      title: '结算状态',
      align: 'center',
      key: 'state',
      width: Dimen.Time,
      ellipsis: true,
      render: (_, t) => {
        return (
          <div
            style={{
              color: t?.state == 5 ? 'red' : '',
            }}
          >
            {t?.state ? getTransactionQueryName(Number(t?.state)) : '-'}
          </div>
        )
      }

    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return r?.batchNo ? r?.batchNo : '-'
      },
    },
    {
      title: '有效期',
      dataIndex: 'deadline',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, r) => {
        return r?.deadline
          ? moment(r.deadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '供应商',
      dataIndex: 'gysName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, r) => {
        return r?.gysName ? r?.gysName : '-'
      },
    },
    {
      title: '医保结算编号',
      align: 'center',
      key: 'yibaojsbh',
      ellipsis: true,
      width: Dimen.IdCardNumber,
      render: (_, t) =>
        t?.yibaojsbh || '-'
    },
    {
      title: '结算就诊编号',
      align: 'center',
      ellipsis: true,
      key: 'yibaojzbh',
      width: Dimen.IdCardNumber,
      render: (_, t) =>
        t?.yibaojzbh || '-'
    },
    {
      title: '医保人员编号',
      align: 'center',
      key: 'yibaorybh',
      ellipsis: true,
      width: Dimen.IdCardNumber,
      render: (_, t) =>
        t?.yibaorybh
    },
    {
      title: '费用明细流水号',
      align: 'center',
      key: 'fymxid',
      width: Dimen.Time,
      ellipsis: true,
      render: (_, t) =>
        t?.fymxid
    },
  ]
  return hisVersion == 1 ? columns : columns.filter(c => c.key !== 'toothStruct')
}

export const TransactionDetailAGColumns = (
  startIndex?: any,
  columnList?: any,
  CKHZSJHData?: boolean,
): ColDef[] => {
  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return (
                  <div style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    合计
                  </div>
                );
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'paymentId': //结算编号
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              return t?.paymentId ? t?.paymentId : '-'
            },
          };
        case 'outpatientNo': //门诊号
        case 'patientName': //患者姓名
        case 'idCardNumber': //身份证号
        case 'disease': //诊断疾病
        case 'treatmentDoctorName': //接诊医生
        case 'drugName': //项目名称
        case 'payMethodName': //支付方式
        case 'batchNo': //批号
        case 'gysName': //供应商
        case 'yibaojsbh': //医保结算编号
        case 'yibaojzbh': //结算就诊编号
        case 'yibaorybh': //医保人员编号
        case 'fymxid': //费用明细流水号
        case 'hilistCode': //医保编码
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return value ? value : '-'
            }
          };
        case 'patientId': //病历号
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value > -1 ? params.value : '-';
            },
          };
        case 'patientPhone': //手机号
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? (!CKHZSJHData ? getMaskPhone(decrypt(params.value)) : decrypt(params.value)) : '-';
            },
          };
        case 'patientSource': //患者来源
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? params.value : '-';
            },
          };
        case 'chargeOrRefundTime': //收费时间
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? moment(params.value)?.format(DateTimeFormat) : '-';
            },
          };
        case 'insuranceCode': //结算险种
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return value === 'ZIFEI' || !value ? '自费' : '智慧医保';
            },
          };
        case 'xianzhonglx': //人员险种
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return value == 310 ? '职工' : value == 390 ? '居民' : value == 340 ? '离休' : '-'
            },
          };
        case 'billingCategory': //开票项目
          return {
            ...item,
            cellStyle: hisVersion == 1 ? { textAlign: 'center', lineHeight: '70px' } : { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return BillingCategoryName(value)
            },
          };
        case 'toothStruct': //牙位
          return {
            ...item,
            cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return <ToothComponents data={params.value} isEdit={false} />
            },
          };
        case 'retailPrice': //单价
        case 'drugAmount': //金额
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                color: t?.state == 5 ? 'red' : '',
                textAlign: 'center',
                lineHeight: hisVersion == 1 ? '70px' : '40px',
              }
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return Number(params.value) > -1 ? params.value.toFixed(2) : '-';
            },
          };
        case 'drugCount': //数量
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                color: t?.state == 5 ? 'red' : '',
                textAlign: 'center',
                lineHeight: hisVersion == 1 ? '70px' : '40px',
              }
            },
            cellRendererFramework: (params: any) => {
              return Number(params.value) > -1 ? params.value : '-';
            },
          };
        case 'chrgitmLv': //甲乙分类
         return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
                lineHeight: hisVersion == 1 ? '70px' : '40px',
             }
           },
           cellRendererFramework: (params: any) => {
              const t = params.data;
             const deadline = moment(t.deadline)
             const duration = moment.duration(deadline.diff(moment()))
             const days = duration.asDays()
             return (
               <>
                 <div>
                   { t.chrgitmLv ? getChrgitmLvName(t.chrgitmLv) : '-'}
                 </div>
               </>
             )
           },
         };
        case 'state': //结算状态
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                color: t?.state == 5 ? 'red' : '',
                textAlign: 'center',
                lineHeight: hisVersion == 1 ? '70px' : '40px',
              }
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? getTransactionQueryName(Number(params.value)) : '-';
            },
          };
        case 'deadline': //有效期
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: hisVersion == 1 ? '70px' : '40px', },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? moment(params.value)?.format(DateTimeFormatSimple) : '-';
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: hisVersion == 1 ? '70px' : '40px', },
          };
      }
    })
  )
}